export enum SessionStatusEnum {
  LOGGING_OUT = 'LOGGING_OUT',
  LOGGED_OUT = 'LOGGED_OUT',
  LOGGED_IN_ONLINE = 'LOGGED_IN_ONLINE',
  LOGGED_IN_OFFLINE = 'LOGGED_IN_OFFLINE',
  LOGGING_IN = 'LOGGING_IN',
  PENDING = 'PENDING',
  NOT_LOGGED = 'NOT_LOGGED',
}

export enum SessionInteractionEnum {
  ASKING_BEFORE_END = 'ASKING_BEFORE_END',
  ASKING_RECONNECT = 'ASKING_RECONNECT',
  ASKING_SESSION_EXPIRED = 'ASKING_SESSION_EXPIRED',
}
